/* eslint-disable consistent-return, import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, no-shadow, no-underscore-dangle, no-useless-escape, prefer-rest-params, react/no-unescaped-entities, react/prop-types */
import { useReducer, useRef } from "react";
import { cn } from "tailwind-variants";
import { filterDomProps } from "common/vue/filter-dom-props";
import { useVueProps, vueDefaultValue } from "common/vue/useVueProps";
/* eslint-disable max-lines-per-function */
import { remoteImageStaticUrl } from "common/utils/remote-image";

// @ts-expect-error TS(6133): 'rawProps' is declared but its value is never read... Remove this comment to see the full error message
function getDefaultProps(rawProps: any) {
  return {
    classes: vueDefaultValue(""),
    inline: vueDefaultValue(false),
    size: vueDefaultValue(""),
    theme: vueDefaultValue("grey"),
    paused: vueDefaultValue(false)
  };
}

export default function Spinner(rawProps: any) {
  const { className, classes, inline, size, theme, paused, ...restProps } = rawProps;

  const props = useVueProps(rawProps, getDefaultProps);
  // @ts-expect-error TS(6133): 'forceUpdate' is declared but its value is never r... Remove this comment to see the full error message
  const [_, forceUpdate] = useReducer(() => ({}), {});

  const pathname = useRef({
    dark: "gen/spinner.png",
    grey: "gen/spinner-grey.png",
    white: "gen/spinner-white.png"
  });

  function classHash() {
    const classHash = {
      spinner: true,
      "spinner--inline": !!props.current.inline
    };
    if (props.current.size) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      classHash[`spinner--size-${props.current.size}`] = true;
    }
    if (props.current.classes) {
      props.current.classes.split(" ").forEach((className: any) => {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        classHash[className] = !0;
      });
    }
    return classHash;
  }

  function imageSource() {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return remoteImageStaticUrl(pathname.current[props.current.theme]);
  }

  return (
    // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
    <div {...filterDomProps(restProps)} className={cn(classHash(), className)}>
      <img
        className={cn("spinner__image", {
          "spinner__image--paused": props.current.paused
        })}
        alt="Loading…"
        src={imageSource()}
        data-testid="spinner-image"
      />
    </div>
  );
}
